
<component :is="layout">
  <slot></slot>
</component>
